export const ONETRUST_MANAGE_COOKIES_LINK = "#cookies";
